import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Container, Header, Icon, Menu, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import InformesFinancierosView from './InformesFinancierosView';
import MensualView from './MensualView';
import CuentasView from './CuentasView';

class FinancieroView extends Component {

  constructor (props) {
    super(props);

    this.state = {

    };

  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container fluid style={{ padding: 16 }}>
        <Header className="no-print" as="h2">
          <Icon name="users" />
          <Header.Content>
            Financiero
            <Header.Subheader>
              Administrar / Consulta de Datos Financieros
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu className="no-print" tabular pointing secondary>
          <Menu.Item
            as={Link} to="/financiero/informes"
            active={!!window.location.pathname.match(new RegExp(`^/financiero/informes/?$`))}
            name="informes" />
          <Menu.Item
            as={Link} to="/financiero/mensual"
            active={!!window.location.pathname.match(new RegExp(`^/financiero/mensual/?$`))}
            name="mensual" />
          <Menu.Item
            as={Link} to="/financiero/cuentas"
            active={!!window.location.pathname.match(new RegExp(`^/financiero/cuentas/?$`))}
            name="cuentas" />
        </Menu>
        <Route path={`${this.props.match.url}/informes`} render={() => {
          return (
            <Segment vertical>
              <InformesFinancierosView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/mensual`} render={() => {
          return (
            <Segment vertical>
              <MensualView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/cuentas`} render={() => {
          return (
            <Segment vertical>
              <CuentasView />
            </Segment>
          );
        }} />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    FinancieroView.mapStateToProps,
    FinancieroView.mapDispatchToProps
  )(FinancieroView)
);



// WEBPACK FOOTER //
// ./client/components/pages/financiero/FinancieroView.js